<div class="block-list {{block_list_class}}"></div>
